import { Form } from "antd";
import React, { useEffect, useState } from "react";
import SaveButton from "../../components/button/saveButton";
import BaseInput from "../../components/form/BaseInput";
import { HomeWrapped } from "./style";
import { useDispatch, useSelector } from "react-redux";
import {
  getHomeContentPageContentRequest,
  postHomeContentPageContentRequest,
} from "../../redux/contentManagementSlice";
import { BannerImage, CONTENT_PAGES, STATUSES } from "../../config/constants/defaultValues";
import Loading from "../../components/shared/GeneralComponents";
import TextAreas from "../../components/form/TextAreas";
import SeoSection from "../../components/shared/seoSection";
import BannerImageCard from "../../components/shared/bannerImageCard";
import VideoCard from "../../components/shared/VideoCard";

const HomeContentPage = () => {
  const dispatch = useDispatch();
  const { homeContentPageData, homeContentPageStatus, homeContentPageError } =
    useSelector((state) => state.contentManagement);
  const [form] = Form.useForm();
  //Seo Section states
  const [ogImageUrl, setOGImageUrl] = useState();
  const [ogImageFile, setOGImageFile] = useState();
  const [twitterImageUrl, setTwitterImageUrl] = useState();
  const [twitterImageFile, setTwitterImageFile] = useState();
  // Banner Video Home Page
  const [bannerSectionVideoUrl, setBannerSectionVideoUrl] = useState();
  const [bannerSectionVideoFile, setBannerSectionVideoFile] = useState();
  // Counter Section Images
  const [counterSectionImageUrl, setCounterSectionImageUrl] = useState();
  const [counterSectionImageFile, setCounterSectionImageFile] = useState();
  // About Section Images
  const [aboutSectionImageUrl, setAboutSectionImageUrl] = useState();
  const [aboutSectionImageFile, setAboutSectionImageFile] = useState();
  // why Choose Section
  const [whyChooseSectionVideoUrl, setWhyChooseSectionVideoUrl] = useState();
  const [whyChooseSectionVideoFile, setWhyChooseSectionVideoFile] = useState();
  const [whyChooseSectionThumbnailImageUrl, setWhyChooseSectionThumbnailImageUrl] = useState();
  const [whyChooseSectionThumbnailImageFile, setWhyChooseSectionThumbnailImageFile] = useState();  
  // Portfolio Section Images
  const [portfolioSectionFirstImageUrl, setPortfolioSectionFirstImageUrl] = useState();
  const [portfolioSectionFirstImageFile, setPortfolioSectionFirstImageFile] = useState();
  const [portfolioSectionSecondImageUrl, setPortfolioSectionSecondImageUrl] = useState();
  const [portfolioSectionSecondImageFile, setPortfolioSectionSecondImageFile] = useState();
  const [portfolioSectionThirdImageUrl, setPortfolioSectionThirdImageUrl] = useState();
  const [portfolioSectionThirdImageFile, setPortfolioSectionThirdImageFile] = useState();
  const [portfolioSectionForthImageUrl, setPortfolioSectionForthImageUrl] = useState();
  const [portfolioSectionForthImageFile, setPortfolioSectionForthImageFile] = useState();
  const [portfolioSectionFifthImageUrl, setPortfolioSectionFifthImageUrl] = useState();
  const [portfolioSectionFifthImageFile, setPortfolioSectionFifthImageFile] = useState();
  useEffect(() => {
    dispatch(getHomeContentPageContentRequest(CONTENT_PAGES.HOME_PAGE));
  }, [dispatch]);

  useEffect(() => {
    if (homeContentPageData) {
      form.setFieldsValue({
        "detail[bannerSection][text]": homeContentPageData?.contentPage?.detail?.bannerSection?.text,
        "detail[bannerSection][heading]": homeContentPageData?.contentPage?.detail?.bannerSection?.heading,
        "detail[bannerSection][description]": homeContentPageData?.contentPage?.detail?.bannerSection?.description,
        "detail[bannerSection][buttonText]": homeContentPageData?.contentPage?.detail?.bannerSection?.buttonText,
        "detail[bannerSection][formHeading]": homeContentPageData?.contentPage?.detail?.bannerSection?.formHeading,
        "detail[bannerSection][formConfirmationText]": homeContentPageData?.contentPage?.detail?.bannerSection?.formConfirmationText,
        "detail[bannerSection][formButtonText]": homeContentPageData?.contentPage?.detail?.bannerSection?.formButtonText,
        "detail[bannerSection][firstCounterValue]": homeContentPageData?.contentPage?.detail?.bannerSection?.firstCounterValue,
        "detail[bannerSection][firstCounterText]": homeContentPageData?.contentPage?.detail?.bannerSection?.firstCounterText,
        "detail[bannerSection][secondCounterValue]": homeContentPageData?.contentPage?.detail?.bannerSection?.secondCounterValue,
        "detail[bannerSection][secondCounterText]": homeContentPageData?.contentPage?.detail?.bannerSection?.secondCounterText,
        "detail[bannerSection][thirdCounterValue]": homeContentPageData?.contentPage?.detail?.bannerSection?.thirdCounterValue,
        "detail[bannerSection][thirdCounterText]": homeContentPageData?.contentPage?.detail?.bannerSection?.thirdCounterText,
        "detail[bannerSection][forthCounterValue]": homeContentPageData?.contentPage?.detail?.bannerSection?.forthCounterValue,
        "detail[bannerSection][forthCounterText]": homeContentPageData?.contentPage?.detail?.bannerSection?.forthCounterText,
        // About Us Section
        "detail[aboutSection][text]": homeContentPageData?.contentPage?.detail?.aboutSection?.text,
        "detail[aboutSection][heading]": homeContentPageData?.contentPage?.detail?.aboutSection?.heading,
        "detail[aboutSection][description]": homeContentPageData?.contentPage?.detail?.aboutSection?.description,
        "detail[aboutSection][subHeading]": homeContentPageData?.contentPage?.detail?.aboutSection?.subHeading,
        "detail[aboutSection][firstBulletPoint]": homeContentPageData?.contentPage?.detail?.aboutSection?.firstBulletPoint,
        "detail[aboutSection][secondBulletPoint]": homeContentPageData?.contentPage?.detail?.aboutSection?.secondBulletPoint,
        "detail[aboutSection][thirdBulletPoint]": homeContentPageData?.contentPage?.detail?.aboutSection?.thirdBulletPoint,
        "detail[aboutSection][buttonText]": homeContentPageData?.contentPage?.detail?.aboutSection?.buttonText,
        "detail[aboutSection][ratingValue]": homeContentPageData?.contentPage?.detail?.aboutSection?.ratingValue,
        "detail[aboutSection][ratingText]": homeContentPageData?.contentPage?.detail?.aboutSection?.ratingText,
        // Why Choose Section
        "detail[whyChooseSection][text]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.text,
        "detail[whyChooseSection][heading]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.heading,
        "detail[whyChooseSection][description]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.description,
        "detail[whyChooseSection][firstSubHeading]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.firstSubHeading,
        "detail[whyChooseSection][firstSubDescription]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.firstSubDescription,
        "detail[whyChooseSection][secondSubHeading]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.secondSubHeading,
        "detail[whyChooseSection][secondSubDescription]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.secondSubDescription,
        "detail[whyChooseSection][thirdSubHeading]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.thirdSubHeading,
        "detail[whyChooseSection][thirdSubDescription]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.thirdSubDescription,
        "detail[whyChooseSection][buttonText]": homeContentPageData?.contentPage?.detail?.whyChooseSection?.buttonText,
        // Services Section Section
        "detail[servicesSection][heading]": homeContentPageData?.contentPage?.detail?.servicesSection?.heading,
        "detail[servicesSection][description]": homeContentPageData?.contentPage?.detail?.servicesSection?.description,
        // Portfolio Section
        "detail[portfolioSection][text]": homeContentPageData?.contentPage?.detail?.portfolioSection?.text,
        "detail[portfolioSection][heading]": homeContentPageData?.contentPage?.detail?.portfolioSection?.heading,
        "detail[portfolioSection][buttonText]": homeContentPageData?.contentPage?.detail?.portfolioSection?.description,
        // Testimonial Section
        "detail[testimonialsSection][text]": homeContentPageData?.contentPage?.detail?.testimonialsSection?.text,
        "detail[testimonialsSection][heading]": homeContentPageData?.contentPage?.detail?.testimonialsSection?.heading,
        // Get Quote Section
        "detail[getQuoteSection][text]": homeContentPageData?.contentPage?.detail?.getQuoteSection?.text,
        "detail[getQuoteSection][heading]": homeContentPageData?.contentPage?.detail?.getQuoteSection?.heading,
        "detail[getQuoteSection][formHeading]": homeContentPageData?.contentPage?.detail?.getQuoteSection?.formHeading,
        "detail[getQuoteSection][formConfirmationText]": homeContentPageData?.contentPage?.detail?.getQuoteSection?.formConfirmationText,
        "detail[getQuoteSection][buttonText]": homeContentPageData?.contentPage?.detail?.getQuoteSection?.buttonText,

        //Seo Values Set
        meta_title: homeContentPageData?.contentPage?.seo_keywords?.meta_title ?? "",
        meta_description: homeContentPageData?.contentPage?.seo_keywords?.meta_description ?? "",
        is_canonical: homeContentPageData?.contentPage?.seo_keywords?.is_canonical === 1 ? true : false,
        robots_meta: homeContentPageData?.contentPage?.seo_keywords?.robots_meta ?? "",
        meta_author: homeContentPageData?.contentPage?.seo_keywords?.meta_author ?? "",
        og_type: homeContentPageData?.contentPage?.seo_keywords?.og_type ?? "",
        og_title: homeContentPageData?.contentPage?.seo_keywords?.og_title ?? "",
        og_description: homeContentPageData?.contentPage?.seo_keywords?.og_description ?? "",
        og_image_width: homeContentPageData?.contentPage?.seo_keywords?.og_image_width ?? "",
        og_image_height: homeContentPageData?.contentPage?.seo_keywords?.og_image_height ?? "",
        og_url: homeContentPageData?.contentPage?.seo_keywords?.og_url ?? "",
        og_site_name: homeContentPageData?.contentPage?.seo_keywords?.og_site_name ?? "",
        og_locale: homeContentPageData?.contentPage?.seo_keywords?.og_locale ?? "",
        og_locale_alternate: homeContentPageData?.contentPage?.seo_keywords?.og_locale_alternate ?? "",
        twitter_card: homeContentPageData?.contentPage?.seo_keywords?.twitter_card ?? "",
        twitter_site: homeContentPageData?.contentPage?.seo_keywords?.twitter_site ?? "",
        twitter_title: homeContentPageData?.contentPage?.seo_keywords?.twitter_title ?? "",
        twitter_description: homeContentPageData?.contentPage?.seo_keywords?.twitter_description ?? "",
        twitter_url: homeContentPageData?.contentPage?.seo_keywords?.twitter_url ?? "",
      });
      setBannerSectionVideoUrl(homeContentPageData?.contentPage?.contentImages?.bannerVideo ?? null);
      setCounterSectionImageUrl(homeContentPageData?.contentPage?.contentImages?.counterSectionImage ?? BannerImage);
      setAboutSectionImageUrl(homeContentPageData?.contentPage?.contentImages?.aboutSectionImage ?? BannerImage);
      setWhyChooseSectionVideoUrl(homeContentPageData?.contentPage?.contentImages?.whyChooseVideo ?? null);
      setWhyChooseSectionThumbnailImageUrl(homeContentPageData?.contentPage?.contentImages?.whyChooseSectionThumbnailImage ?? BannerImage);
      setTwitterImageUrl(homeContentPageData?.contentPage?.seo_keywords?.twitter_image ?? BannerImage);
      setOGImageUrl(homeContentPageData?.contentPage?.seo_keywords?.og_image ?? BannerImage);
    }
  }, [homeContentPageData, form]);

  const onUpdate = (values) => {
    const data = {
      ...values,

      name: 'Home Page',
      "og_image": ogImageFile ?? "",
      "twitter_image": twitterImageFile ?? "",
      "is_canonical": values.is_canonical === true ? 1 : 0,
      "contentImages[bannerVideo]": bannerSectionVideoFile ?? "",
      "contentImages[counterSectionImage]": counterSectionImageFile ?? "",
      "contentImages[aboutSectionImage]": aboutSectionImageFile ?? "",
      "contentImages[whyChooseVideo]": whyChooseSectionVideoFile ?? "",
      "contentImages[whyChooseSectionThumbnailImage]": whyChooseSectionThumbnailImageFile ?? "",
      _method: 'PUT'
    }
    dispatch(postHomeContentPageContentRequest({ data, id: CONTENT_PAGES.HOME_PAGE }))
  };

  return (
    <>
      {homeContentPageStatus === STATUSES.LOADING ? (
        <Loading />
      ) : homeContentPageStatus === STATUSES.ERROR ? (
        <div>{homeContentPageError}</div>
      ) : (
        <HomeWrapped>
          <div className="row">
            <div className="col-lg-12">
              <Form
                layout="vertical"
                className="pt-3"
                form={form}
                onFinish={onUpdate}
              >
                {/* <div className="row">
                  <div className="col-sm-12 d-flex justify-content-between align-items-start mb-4">
                    <h3 className="font-bold" >Home</h3>
                    <SaveButton title="Update" />
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-lg-9 col-12 d-flex justify-content-between align-items-start mb-4">
                    <h3 className="font-bold" >Home</h3>
                    <SaveButton title="Update" />
                  </div>
                  <div className="col-lg-9 col-12">
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Text"
                      name="detail[bannerSection][text]"
                      placeText="Banner Section Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Heading"
                      name="detail[bannerSection][heading]"
                      placeText="Banner Section Heading"
                    />
                    <TextAreas
                      labelText="Banner Section Description"
                      name="detail[bannerSection][description]"
                      placeText="Banner Section Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Button Text"
                      name="detail[bannerSection][buttonText]"
                      placeText="Banner Section Button Text"
                    />
                    <label>Banner Section Video *</label>
                    <VideoCard
                      width={400} height={300}
                      videoUrl={bannerSectionVideoUrl}
                      setVideoFile={setBannerSectionVideoFile}
                      setVideoUrl={setBannerSectionVideoUrl}
                    />
                    <br/>
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Form Heading"
                      name="detail[bannerSection][formHeading]"
                      placeText="Banner Section Form Heading"
                    />
                    <TextAreas
                      labelText="Banner Section Form Confirmation Text"
                      name="detail[bannerSection][formConfirmationText]"
                      placeText="Banner Section Form Confirmation Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Form Button Text"
                      name="detail[bannerSection][formButtonText]"
                      placeText="Banner Section Form Button Text"
                    />
                    <BannerImageCard
                      title="Counter Section Image"
                      imageUrl={counterSectionImageUrl}
                      isBlogImage={true}
                      setImageFile={setCounterSectionImageFile}
                      setImageUrl={setCounterSectionImageUrl}
                      imageText="Change Image"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section First Counter Value"
                      name="detail[bannerSection][firstCounterValue]"
                      placeText="Banner Section First Counter Value"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section First Counter Text"
                      name="detail[bannerSection][firstCounterText]"
                      placeText="Banner Section First Counter Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Second Counter Value"
                      name="detail[bannerSection][secondCounterValue]"
                      placeText="Banner Section Second Counter Value"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Second Counter Text"
                      name="detail[bannerSection][secondCounterText]"
                      placeText="Banner Section Second Counter Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Third Counter Value"
                      name="detail[bannerSection][thirdCounterValue]"
                      placeText="Banner Section Third Counter Value"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Third Counter Text"
                      name="detail[bannerSection][thirdCounterText]"
                      placeText="Banner Section Third Counter Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Forth Counter Value"
                      name="detail[bannerSection][forthCounterValue]"
                      placeText="Banner Section Forth Counter Value"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Forth Counter Text"
                      name="detail[bannerSection][forthCounterText]"
                      placeText="Banner Section Forth Counter Text"
                    />
                    {/* About Us Section */}
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Text"
                      name="detail[aboutSection][text]"
                      placeText="About Section Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Heading"
                      name="detail[aboutSection][heading]"
                      placeText="About Section Heading"
                    />
                    <TextAreas
                      labelText="About Section Description"
                      name="detail[aboutSection][description]"
                      placeText="About Section Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Sub Heading"
                      name="detail[aboutSection][subHeading]"
                      placeText="About Section Sub Heading"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section First Bullet Point"
                      name="detail[aboutSection][firstBulletPoint]"
                      placeText="About Section First Bullet Point"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Second Bullet Point"
                      name="detail[aboutSection][secondBulletPoint]"
                      placeText="About Section Second Bullet Point"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Third Bullet Point"
                      name="detail[aboutSection][thirdBulletPoint]"
                      placeText="About Section Third Bullet Point"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Button Text"
                      name="detail[aboutSection][buttonText]"
                      placeText="About Section Button Text"
                    />
                    <BannerImageCard
                      title="About Section Image"
                      imageUrl={aboutSectionImageUrl}
                      isBlogImage={true}
                      setImageFile={setAboutSectionImageFile}
                      setImageUrl={setAboutSectionImageUrl}
                      imageText="Change Image"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Rating Value"
                      name="detail[aboutSection][ratingValue]"
                      placeText="About Section Rating Value"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="About Section Rating Text"
                      name="detail[aboutSection][ratingText]"
                      placeText="About Section Rating Text"
                    />
                    {/* Why Choose section */}
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Why Choose Section Section Text"
                      name="detail[whyChooseSection][text]"
                      placeText="Why Choose Section Section Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Why Choose Section Section Heading"
                      name="detail[whyChooseSection][heading]"
                      placeText="Why Choose Section Section Heading"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Why Choose Section First Sub-Heading"
                      name="detail[whyChooseSection][firstSubHeading]"
                      placeText="Why Choose Section First Sub-Heading"
                    />
                    <TextAreas
                      labelText="Why Choose Section First Sub-Description"
                      name="detail[whyChooseSection][firstSubDescription]"
                      placeText="Why Choose Section First Sub-Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Why Choose Section Second Sub-Heading"
                      name="detail[whyChooseSection][secondSubHeading]"
                      placeText="Why Choose Section Second Sub-Heading"
                    />
                    <TextAreas
                      labelText="Why Choose Section Second Sub-Description"
                      name="detail[whyChooseSection][secondSubDescription]"
                      placeText="Why Choose Section Second Sub-Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Why Choose Section Third Sub-Heading"
                      name="detail[whyChooseSection][thirdSubHeading]"
                      placeText="Why Choose Section Third Sub-Heading"
                    />
                    <TextAreas
                      labelText="Why Choose Section Third Sub-Description"
                      name="detail[whyChooseSection][thirdSubDescription]"
                      placeText="Why Choose Section Third Sub-Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Why Choose Section Button Text"
                      name="detail[whyChooseSection][buttonText]"
                      placeText="Why Choose Section Button Text"
                    />
                    <label>Why Choose  Section Video *</label>
                    <VideoCard
                      width={400} height={300}
                      videoUrl={whyChooseSectionVideoUrl}
                      setVideoFile={setWhyChooseSectionVideoFile}
                      setVideoUrl={setWhyChooseSectionVideoUrl}
                    />
                    <br/>
                    <BannerImageCard
                      title="Why Choose Section Thumbnail Image"
                      imageUrl={whyChooseSectionThumbnailImageUrl}
                      isBlogImage={true}
                      setImageFile={setWhyChooseSectionThumbnailImageFile}
                      setImageUrl={setWhyChooseSectionThumbnailImageUrl}
                      imageText="Change Image"
                    />
                    {/* Services Section */}
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Services Section Heading"
                      name="detail[servicesSection][heading]"
                      placeText="Services Section Heading"
                    />
                    <TextAreas
                      labelText="Services Section Description"
                      name="detail[servicesSection][description]"
                      placeText="Services Section Description"
                    />
                    {/* Portfolio Section */}
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Portfolio Section Text"
                      name="detail[portfolioSection][text]"
                      placeText="Portfolio Section Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Portfolio Section Heading"
                      name="detail[portfolioSection][heading]"
                      placeText="Portfolio Section Heading"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Portfolio Section Button Text"
                      name="detail[portfolioSection][buttonText]"
                      placeText="Portfolio Section Text"
                    />
                    {/* Testimonial section */}
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Testimonials Section Text"
                      name="detail[testimonialsSection][text]"
                      placeText="Testimonials Section Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Testimonials Section Heading"
                      name="detail[testimonialsSection][heading]"
                      placeText="Testimonials Section Heading"
                    />
                    {/* Get Quote section */}
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Get Quote Section Text"
                      name="detail[getQuoteSection][text]"
                      placeText="Get Quote Section Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Get Quote Section Heading"
                      name="detail[getQuoteSection][heading]"
                      placeText="Get Quote Section Heading"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Get Quote Section Form Heading"
                      name="detail[getQuoteSection][formHeading]"
                      placeText="Get Quote Section Form Heading"
                    />
                    <TextAreas
                      labelText="Get Quote Section Form Confirmation Text"
                      name="detail[getQuoteSection][formConfirmationText]"
                      placeText="Get Quote Section Form Confirmation Text"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Get Quote Section Button Text"
                      name="detail[getQuoteSection][buttonText]"
                      placeText="Get Quote Section Button Text"
                    />
                  </div>
                  <SeoSection ogImageUrl={ogImageUrl}
                    setOGImageFile={setOGImageFile}
                    setOGImageUrl={setOGImageUrl}
                    twitterImageUrl={twitterImageUrl}
                    setTwitterImageFile={setTwitterImageFile}
                    setTwitterImageUrl={setTwitterImageUrl} />
                </div>
              </Form>
            </div>
          </div>
        </HomeWrapped>
      )}
    </>
  );
};

export default HomeContentPage;
